import React from 'react';
import { useParams } from 'react-router-dom';
import "./BankingRightTab_patient.css";
import PatientInfo from './PatientInfo';

// 1. 함수 재생성을 막기 위해 컴포넌트 바깥으로 빼냅니다.
// 2. 혹시 모를 여러 개의 hashmark를 모두 바꾸기 위해 정규식(/g)을 사용합니다.
// 3. 값이 없을 때 에러가 나지 않도록 방어 코드를 넣습니다.
const restoreHashMark = (str) => {
    if (!str) return '';
    return str.replace(/hashmark/g, '#');
};

// 4. 컴포넌트 이름의 오타(Rigth -> Right)를 수정했습니다.
function BankingRightTab() {
    const { tmpKey } = useParams();

    return (
        <div className="rightTabMain">
            <div className="currentPatient">
                현재 환자 : {restoreHashMark(tmpKey)}
            </div>
            <div>
                {/* 닫는 태그를 간소화하여 코드를 깔끔하게 만듭니다 */}
                <PatientInfo param={tmpKey} />
            </div>
        </div>
    );
}

export default BankingRightTab;